/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useHistory, useLocation } from "react-router-dom";
import isEmail from "validator/lib/isEmail";

import { api } from "../../services/api";
import { TOASTIFY_OPTIONS } from "../../style/global";
import { LoginForm, MyPage } from "./style";
import spreadChatLogo from "../../assets/logo-eloz-spread.png";

function Login() {
	const [email, setEmail] = useState();
	const [senha, setSenha] = useState();
	const { push } = useHistory();
	const query = new URLSearchParams(useLocation().search);

	useEffect(() => {
		const isFromEmail = Boolean(query.get("fromEmail"));
		const email = query.get("email");
		if (!isFromEmail) {
			return;
		}
		setEmail(email);
	}, []);

	const handleSendSubmit = async (e) => {
		e.preventDefault();
		if (!email) {
			toast.error("Informe seu email", TOASTIFY_OPTIONS);
			return;
		}
		if (!isEmail(email.trim())) {
			toast.error("Informe um email válido", TOASTIFY_OPTIONS);
			return;
		}
		if (!senha) {
			toast.error("Informe sua senha", TOASTIFY_OPTIONS);
			return;
		}
		try {
			const { data } = await api.post("/login", {
				email: email,
				password: senha,
			});
			if (data.logged) {
				localStorage.setItem("token", data.token);
				localStorage.setItem("@SpreadChat:authUser", data.authUser);
				push("/accounts");
			} else {
				toast.error("Email ou Senha Inválido!", TOASTIFY_OPTIONS);
			}
		} catch (error) {
			console.error(error);
		}
	};

	return (
		<MyPage>
			<LoginForm onSubmit={handleSendSubmit}>
				<img
					src={spreadChatLogo}
					style={{
						width: "200px",
						margin: "auto",
						marginTop: "150px",
						marginBottom: "50px",
					}}
					alt="logo"
				/>
				<label>Email</label>
				<input
					placeholder="email@example.com"
					type="email"
					onChange={(e) => setEmail(e.target.value)}
					value={email}
				/>
				<label>Senha</label>
				<input
					placeholder=""
					type="password"
					onChange={(e) => setSenha(e.target.value)}
					value={senha}
				/>
				<button type="submit">Login</button>
			</LoginForm>
		</MyPage>
	);
}

export default Login;
